import React from 'react'

const HtmlBanners = () => {
    return (
        <div className="htmlbanners flex">
            <iframe 
                src="./img/marketing-campaigns/banners/Enercare_LightUp_EN/Enercare_LightUp_EN.html" 
                width="300"
                height="250"
                style={{'display': 'block'}}
                title="Audi Winter Wheels 2016"
            ></iframe>
            <iframe 
                src="./img/marketing-campaigns/banners/Audi_TOR_Q3_EN/Audi_TOR_Q3_EN.html" 
                width="300"
                height="250"
                style={{'display': 'block'}}
                title="Enercare Light Up"
            ></iframe>
        </div>
    )
}

export default HtmlBanners